import {
  createEntityAdapter,
  createSlice,
  createReducer,
  configureStore,
} from '@reduxjs/toolkit'
import reducers from './reducers'

const adapter = createEntityAdapter()

const store = configureStore({
  reducer: reducers,
  devTools: {
    name: 'Survey overview',
  },
})

export default store
